<template>
  <div class="tab-panel">
    <div class="senate-buttons">
      <button type="button" @click="senateActive = '0'" :class="['senate-btn', { active: senateActive === '0' }]">Resolutions</button>
      <button type="button" @click="senateActive = '1'" :class="['senate-btn', { active: senateActive === '1' }]">Bills on First Reading</button>
      <button type="button" @click="senateActive = '2'" :class="['senate-btn', { active: senateActive === '2' }]">Unnumbered Substitute Bill</button>
      <button type="button" @click="senateActive = '3'" :class="['senate-btn', { active: senateActive === '3' }]">Committee Report / Substitute Bill</button>
      <button type="button" @click="senateActive = '4'" :class="['senate-btn', { active: senateActive === '4' }]">Bills on Third Reading</button>
    </div>

    <div class="senate-accordion">
      <!-- Senate Resolutions -->
      <div v-show="senateActive === '0'" class="accordion-panel">
        <h4>Senate Resolutions</h4>
        <div v-for="(resolution, num) in senateData.resolutions" :key="num" class="resolution-item">
          <div class="item-header">
            <h5>Resolution #{{ num + 1 }}</h5>
            <Button type="button" @click="deleteSenateResolution(num)" :disabled="isSubButtonDisabled" :class="['delete-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Resolution Title:</label>
              <InputText v-model="resolution.title" type="text" />
            </div>
            <div class="form-group">
              <label>Date Filed:</label>
              <InputText v-model="resolution.datefiled" type="date" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Resolution No.:</label>
              <InputText v-model="resolution.no" type="text" />
            </div>
            <div class="form-group">
              <label>Referred to Committee:</label>
              <MultiSelect v-model="resolution.committee" :options="referrals" placeholder="Select Committee" class="w-full" filter />
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              <MultiSelect v-model="resolution.authors" :options="authors" placeholder="Select Author" class="w-full" filter />
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            <Textarea v-model="resolution.remarks" rows="2"></Textarea>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            <Textarea v-model="resolution.salient_features" rows="2" placeholder="Enter salient features..."></Textarea>
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
              <Button type="button" @click="addSenateResolutionLegisStatus(num)" :disabled="isSubButtonDisabled" :class="['add-sub-btn', { disabled: isSubButtonDisabled }]">Add Legislative Status</Button>
            </div>
            <div v-for="(status, sidx) in resolution.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
                <Button type="button" @click="deleteSenateResolutionLegisStatus(num, sidx)" :disabled="isSubButtonDisabled" :class="['delete-sub-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  <Select v-model="status.status" :options="statusResolutions"/>
          
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  <DatePicker v-model="status.date" @date-select="dateSelect"/>
                </div>
              </div>
            </div>
          </div>


        </div>
        <Button type="button" @click="addSenateResolution" :disabled="isSubButtonDisabled" :class="['add-btn', { disabled: isSubButtonDisabled }]">Add Resolution</Button>
        
        <!-- Position Papers Section for Resolutions -->
        <PositionPaper 
          :positionPapers="senateResolutionsPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusResolutions"
          @addPositionPaper="() => $emit('addPositionPaper', 'senate', 'resolution')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'senate', 'resolution', index)"
        />
      </div>

      <!-- Senate First Reading -->
      <div v-show="senateActive === '1'" class="accordion-panel">
        <h4>Senate Bills on First Reading</h4>
        <div v-for="(bill, num) in senateData.firstreading" :key="num" class="bill-item">
          <div class="item-header">
            <h5>Bill #{{ num + 1 }}</h5>
            <Button type="button" @click="deleteSenateFirstReading(num)" :disabled="isSubButtonDisabled" :class="['delete-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              <InputText v-model="bill.title" type="text" />
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              <InputText v-model="bill.shorttitle" type="text" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill No.:</label>
              <InputText v-model="bill.no" type="text" />
            </div>
            <div class="form-group">
              <label>Date Filed:</label>
              <DatePicker v-model="bill.datefiled" @date-select="dateSelect"/>
            </div>
            <div class="form-group">
              <label>Referred to Committee:</label>
              <MultiSelect v-model="bill.committee" :options="referrals" placeholder="Select Committee" class="w-full" filter />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Author(s):</label>
              <MultiSelect v-model="bill.authors" :options="authors" placeholder="Select Author" class="w-full" filter />
            </div>
            <div class="form-group">
              <label>Source/Link:</label>
              <input v-model="bill.source" type="text">
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            <Textarea v-model="bill.remarks" rows="2"></Textarea>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            <Textarea v-model="bill.salient_features" rows="2" placeholder="Enter salient features..."></Textarea>
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
              <Button type="button" @click="addSenateFirstReadingLegisStatus(num)" :disabled="isSubButtonDisabled" :class="['add-sub-btn', { disabled: isSubButtonDisabled }]">Add Legislative Status</Button>
            </div>
            <div v-for="(status, sidx) in bill.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
                <Button type="button" @click="deleteSenateFirstReadingLegisStatus(num, sidx)" :disabled="isSubButtonDisabled" :class="['delete-sub-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  <Select v-model="status.status" :options="statusFirstReading" />
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  <DatePicker v-model="status.date" @date-select="dateSelect"/>
                </div>
              </div>
            </div>
          </div>


        </div>
        <Button type="button" @click="addSenateFirstReading" :disabled="isSubButtonDisabled" :class="['add-btn', { disabled: isSubButtonDisabled }]">Add First Reading Bill</Button>
        
        <!-- Position Papers Section for First Reading -->
        <PositionPaper 
          :positionPapers="senateFirstReadingPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusFirstReading"
          @addPositionPaper="() => $emit('addPositionPaper', 'senate', 'first_reading')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'senate', 'first_reading', index)"
        />
      </div>

      <!-- Senate Unnumbered -->
      <div v-show="senateActive === '2'" class="accordion-panel">
        <h4>Senate Unnumbered Substitute Bills</h4>
        <div v-for="(bill, num) in senateData.unnumbered" :key="num" class="bill-item">
          <div class="item-header">
            <h5>Unnumbered Bill #{{ num + 1 }}</h5>
            <Button type="button" @click="deleteSenateUnnumbered(num)" :disabled="isSubButtonDisabled" :class="['delete-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              <InputText v-model="bill.title" />
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              <InputText v-model="bill.shorttitle" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Substituting:</label>
              <InputText v-model="bill.substituting" />
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              <MultiSelect v-model="bill.authors" :options="authors" placeholder="Select Author" class="w-full" filter />
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            <Textarea v-model="bill.remarks" rows="2" placeholder="Enter remarks"></Textarea>
          </div>
          <div class="form-group">
            <label>Source/Link:</label>
            <Textarea v-model="bill.source" rows="2"></Textarea>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            <Textarea v-model="bill.salient_features" rows="2" placeholder="Enter salient features..."></Textarea>
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
              <Button type="button" @click="addSenateUnnumberedLegisStatus(num)" :disabled="isSubButtonDisabled" :class="['add-sub-btn', { disabled: isSubButtonDisabled }]">Add Legislative Status</Button>
            </div>
            <div v-for="(status, sidx) in bill.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
                <Button type="button" @click="deleteSenateUnnumberedLegisStatus(num, sidx)" :disabled="isSubButtonDisabled" :class="['delete-sub-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  <Select v-model="status.status" :options="statusFirstReading" />
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  <DatePicker v-model="status.date" @date-select="dateSelect"/>
                </div>
              </div>
            </div>
          </div>


        </div>
        <Button type="button" @click="addSenateUnnumbered" :disabled="isSubButtonDisabled" :class="['add-btn', { disabled: isSubButtonDisabled }]">Add Unnumbered Bill</Button>
        
        <!-- Position Papers Section for Unnumbered Bills -->
        <PositionPaper 
          :positionPapers="senateUnnumberedPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusUnnumbered"
          @addPositionPaper="() => $emit('addPositionPaper', 'senate', 'unnumbered')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'senate', 'unnumbered', index)"
        />
      </div>

      <!-- Senate Committee -->
      <div v-show="senateActive === '3'" class="accordion-panel">
        <h4>Senate Committee Report / Substitute Bill</h4>
        <div class="bill-item">
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              <InputText v-model="senateData.committee.billtitle" />
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              <InputText v-model="senateData.committee.shorttitle" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Committee Report No.:</label>
              <InputText v-model="senateData.committee.no" />
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              <MultiSelect v-model="senateData.committee.authors" :options="authors" placeholder="Select Author" class="w-full" filter />
            </div>
          </div>
          <div class="form-group">
            <label>Remarks:</label>
            <Textarea v-model="senateData.committee.remarks" rows="2"></Textarea>
          </div>
          <div class="form-group">
            <label>Source/Link:</label>
            <Textarea v-model="senateData.committee.source" rows="2"></Textarea>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            <Textarea v-model="senateData.committee.salient_features" rows="2" placeholder="Enter salient features..."></Textarea>
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
              <Button type="button" @click="addSenateCommitteeLegisStatus()" :disabled="isSubButtonDisabled" :class="['add-sub-btn', { disabled: isSubButtonDisabled }]">Add Legislative Status</Button>
            </div>
            <div v-for="(status, sidx) in senateData.committee.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
                <Button type="button" @click="deleteSenateCommitteeLegisStatus(sidx)" :disabled="isSubButtonDisabled" :class="['delete-sub-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  <Select v-model="status.status" :options="statusCommitteeReport"/>
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  <DatePicker v-model="status.date" @date-select="dateSelect"/>
                </div>
              </div>
            </div>
          </div>

        </div>
        
        <!-- Position Papers Section for Committee Reports -->
        <PositionPaper 
          :positionPapers="senateCommitteePositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusCommitteeReport"
          @addPositionPaper="() => $emit('addPositionPaper', 'senate', 'committee_report')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'senate', 'committee_report', index)"
        />
      </div>

      <!-- Senate Third Reading -->
      <div v-show="senateActive === '4'" class="accordion-panel">
        <h4>Senate Bills on Third Reading</h4>
        <div class="bill-item">
          <div class="form-grid">
            <div class="form-group">
              <label>Bill Title:</label>
              <InputText v-model="senateData.thirdreading.billtitle" />
            </div>
            <div class="form-group">
              <label>Short Title:</label>
              <InputText v-model="senateData.thirdreading.shorttitle" />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Bill No.:</label>
              <InputText v-model="senateData.thirdreading.no" />
            </div>
            <div class="form-group">
              <label>Author(s):</label>
              <MultiSelect v-model="senateData.thirdreading.authors" :options="authors" placeholder="Select Author" class="w-full" filter />
            </div>
          </div>
          <div class="form-grid">
            <div class="form-group">
              <label>Remarks:</label>
              <Textarea v-model="senateData.thirdreading.remarks" rows="2"></Textarea>
            </div>
            <div class="form-group">
              <label>Source/Link:</label>
              <Textarea v-model="senateData.thirdreading.link" rows="2"></Textarea>
            </div>
          </div>
          <div class="form-group">
            <label>Salient Features:</label>
            <Textarea v-model="senateData.thirdreading.salient_features" rows="3" placeholder="Enter salient features..."></Textarea>
          </div>

          <!-- Legislative Status Section -->
          <div class="subsection">
            <div class="subsection-header">
              <h6>Legislative Status</h6>
              <Button type="button" @click="addSenateThirdReadingLegisStatus()" :disabled="isSubButtonDisabled" :class="['add-sub-btn', { disabled: isSubButtonDisabled }]">Add Legislative Status</Button>
            </div>
            <div v-for="(status, sidx) in senateData.thirdreading.legisstatus" :key="sidx" class="status-item">
              <div class="status-header">
                <span>Status #{{ sidx + 1 }}</span>
                <Button type="button" @click="deleteSenateThirdReadingLegisStatus(sidx)" :disabled="isSubButtonDisabled" :class="['delete-sub-btn', { disabled: isSubButtonDisabled }]">Delete</Button>
              </div>
              <div class="form-grid">
                <div class="form-group">
                  <label>Status:</label>
                  <Select v-model="status.status" :options="statusThirdReading"/>
                </div>
                <div class="form-group">
                  <label>Date:</label>
                  <DatePicker v-model="status.date" @date-select="dateSelect" />
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Position Papers Section for Third Reading -->
        <PositionPaper 
          :positionPapers="senateThirdReadingPositionPapers"
          :isDisabled="isSubButtonDisabled"
          :statusOptions="statusThirdReading"
          @addPositionPaper="() => $emit('addPositionPaper', 'senate', 'third_reading')"
          @deletePositionPaper="(index) => $emit('deletePositionPaper', 'senate', 'third_reading', index)"
        />
      </div>
    </div>

    <!-- Senate Key Issues Section -->
    <KeyIssuesSection 
      :keyIssues="keyIssues"
      :activeTab="keyIssuesActive"
      :revenueStartYear="revenueStartYear"
      :revenueEndYear="revenueEndYear"
      :budgetaryStartYear="budgetaryStartYear"
      :budgetaryEndYear="budgetaryEndYear"
      @update:activeTab="keyIssuesActive = $event"
      @update:keyIssues="$emit('update:keyIssues', $event)"
      @addRevenueRow="$emit('addSenateRevenueRow')"
      @addBudgetaryRow="$emit('addSenateBudgetaryRow')"
      @addDofConcernsRow="$emit('addSenateDofConcernsRow')"
      @deleteRevenueRow="$emit('deleteSenateRevenueRow', $event)"
      @deleteBudgetaryRow="$emit('deleteSenateBudgetaryRow', $event)"
      @deleteDofConcernsRow="$emit('deleteSenateDofConcernsRow', $event)"
      @getYearTotal="$emit('getYearTotal', $event)"
      @autoResize="$emit('autoResize', $event)"
      @updateRevenueStartYear="$emit('updateRevenueStartYear', $event)"
      @updateRevenueEndYear="$emit('updateRevenueEndYear', $event)"
      @updateBudgetaryStartYear="$emit('updateBudgetaryStartYear', $event)"
      @updateBudgetaryEndYear="$emit('updateBudgetaryEndYear', $event)"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import MultiSelect from 'primevue/multiselect'
import KeyIssuesSection from './KeyIssuesSection.vue'
import PositionPaper from './PositionPaper.vue'

import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Taipei')

const dateSelect = () => {
  Date.prototype.toJSON = function(){ return moment(this).format(); }
    moment().tz("Asia/Taipei").format();
}

const props = defineProps({
  senateData: {
    type: Object,
    required: true
  },
  keyIssues: {
    type: Object,
    required: true
  },
  referrals: {
    type: Array,
    default: () => []
  },
  authors: {
    type: Array,
    default: () => []
  },
  isSubButtonDisabled: {
    type: Boolean,
    default: false
  },
  revenueStartYear: {
    type: Number,
    default: () => new Date().getFullYear()
  },
  revenueEndYear: {
    type: Number,
    default: () => new Date().getFullYear() + 5
  },
  budgetaryStartYear: {
    type: Number,
    default: () => new Date().getFullYear()
  },
  budgetaryEndYear: {
    type: Number,
    default: () => new Date().getFullYear() + 5
  },
  positionPapers: {
    type: Array,
    default: () => []
  },
  senateActiveTab: {
    type: String,
    default: '2'
  }
})

const emit = defineEmits([
  'trackDeletedId',
  'addSenateRevenueRow',
  'addSenateBudgetaryRow',
  'addSenateDofConcernsRow',
  'deleteSenateRevenueRow',
  'deleteSenateBudgetaryRow',
  'deleteSenateDofConcernsRow',
  'getYearTotal',
  'autoResize',
  'addPositionPaper',
  'deletePositionPaper',
  'update:keyIssues',
  'updateRevenueStartYear',
  'updateRevenueEndYear',
  'updateBudgetaryStartYear',
  'updateBudgetaryEndYear'
])

const senateActive = ref(props.senateActiveTab)
const keyIssuesActive = ref('revenue')

watch(() => props.senateActiveTab, (newValue) => {
  senateActive.value = newValue
})

const senateResolutionsPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'senate' && p.sub_type === 'resolution')
)
const senateFirstReadingPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'senate' && p.sub_type === 'first_reading')
)
const senateUnnumberedPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'senate' && p.sub_type === 'unnumbered')
)
const senateCommitteePositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'senate' && p.sub_type === 'committee_report')
)
const senateThirdReadingPositionPapers = computed(() => 
  props.positionPapers.filter(p => p.type === 'senate' && p.sub_type === 'third_reading')
)

const statusResolutions = [
  'Briefing',
  '1st Public Hearing',
  '2nd Public Hearing',
  '3rd Public Hearing',
  'TWG',
  'Approved/Adopted Resolutions'
]

const statusFirstReading = [
  'Briefing',
  '1st Public Hearing',
  '2nd Public Hearing',
  '3rd Public Hearing',
  'TWG',
  'Approved/Adopted Resolutions'
]

const statusUnnumbered = [
  'Briefing',
  '1st Public Hearing',
  '2nd Public Hearing',
  '3rd Public Hearing',
  'TWG',
  'Approved/Adopted Resolutions'
]

const statusCommitteeReport = [
  'Period of Sponsorship',
  'Period of Interpellations',
  'Period of Amendments',
  'Approved on Second Reading'
]

const statusThirdReading = [
  'Approved on Third Reading',
  'Transmitted to House'
]

const addSenateResolution = () => {
  props.senateData.resolutions.push({
    title: '', datefiled: '', no: '', committee: '', authors: '', remarks: '',
    type: 'senate',
    legisstatus: [],
    positionpapers: [],
    revenueimpacts: []
  })
}

const addSenateFirstReading = () => {
  props.senateData.firstreading.push({
    title: '', shorttitle: '', no: '', authors: '', datefiled: '', committee: '', remarks: '', source: '',
    type: 'senate',
    legisstatus: [],
    positionpapers: []
  })
}

const addSenateUnnumbered = () => {
  props.senateData.unnumbered.push({
    title: '', shorttitle: '', substituting: '', authors: '', remarks: '', source: '',
    type: 'senate',
    legisstatus: [],
    positionpapers: []
  })
}


const deleteSenateResolution = (index) => {
  const paper = props.senateData.resolutions[index]
  emit('trackDeletedId', 'bills', paper.id)
  props.senateData.resolutions.splice(index, 1)
}

const deleteSenateFirstReading = (index) => {
  const paper = props.senateData.firstreading[index]
  emit('trackDeletedId', 'bills', paper.id)
  props.senateData.firstreading.splice(index, 1)
}

const deleteSenateUnnumbered = (index) => {
  const paper = props.senateData.unnumbered[index]
  emit('trackDeletedId', 'bills', paper.id)
  props.senateData.unnumbered.splice(index, 1)
}

const addSenateResolutionLegisStatus = (resolutionIndex) => {
  props.senateData.resolutions[resolutionIndex].legisstatus.push({ status: '', date: '' })
}

const deleteSenateResolutionLegisStatus = (resolutionIndex, statusIndex) => {
  const status = props.senateData.resolutions[resolutionIndex].legisstatus[statusIndex]
  emit('trackDeletedId', 'legislative_status', status.id)
  props.senateData.resolutions[resolutionIndex].legisstatus.splice(statusIndex, 1)
}

const addSenateFirstReadingLegisStatus = (billIndex) => {
  props.senateData.firstreading[billIndex].legisstatus.push({ status: '', date: '' })
}

const deleteSenateFirstReadingLegisStatus = (billIndex, statusIndex) => {
  const status = props.senateData.firstreading[billIndex].legisstatus[statusIndex]
  emit('trackDeletedId', 'legislative_status', status.id)
  props.senateData.firstreading[billIndex].legisstatus.splice(statusIndex, 1)
}

const addSenateUnnumberedLegisStatus = (billIndex) => {
  props.senateData.unnumbered[billIndex].legisstatus.push({ status: '', date: '' })
}

const deleteSenateUnnumberedLegisStatus = (billIndex, statusIndex) => {
  const status = props.senateData.unnumbered[billIndex].legisstatus[statusIndex]
  emit('trackDeletedId', 'legislative_status', status.id)
  props.senateData.unnumbered[billIndex].legisstatus.splice(statusIndex, 1)
}

const addSenateCommitteeLegisStatus = () => {
  if (!props.senateData.committee.legisstatus) {
    props.senateData.committee.legisstatus = []
  }
  props.senateData.committee.legisstatus.push({ status: '', date: '' })
}

const deleteSenateCommitteeLegisStatus = (statusIndex) => {
  const status = props.senateData.committee.legisstatus[statusIndex]
  emit('trackDeletedId', 'legislative_status', status.id)
  props.senateData.committee.legisstatus.splice(statusIndex, 1)
}

const addSenateThirdReadingLegisStatus = () => {
  if (!props.senateData.thirdreading.legisstatus) {
    props.senateData.thirdreading.legisstatus = []
  }
  props.senateData.thirdreading.legisstatus.push({ status: '', date: '' })
}

const deleteSenateThirdReadingLegisStatus = (statusIndex) => {
  const status = props.senateData.thirdreading.legisstatus[statusIndex]
  emit('trackDeletedId', 'legislative_status', status.id)
  props.senateData.thirdreading.legisstatus.splice(statusIndex, 1)
}
</script>

<style scoped>
.senate-buttons {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.senate-btn {
  background: #f3f4f6;
  border: 2px solid #e5e7eb;
  color: #374151;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.85rem;
}

.senate-btn:hover {
  background: #e5e7eb;
  border-color: #d1d5db;
}

.senate-btn.active {
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  color: white;
  border-color: #7c3aed;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
}

.accordion-panel {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 2px solid #e5e7eb;
  margin-bottom: 1rem;
}

.accordion-panel h4 {
  color: #7c3aed;
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #8b5cf6;
}

.resolution-item, .bill-item {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.item-header h5 {
  color: #7c3aed;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #7c3aed;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

.subsection {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.subsection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}

.subsection-header h6 {
  color: #7c3aed;
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
}

.status-item, .position-item {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.status-header, .position-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.9rem;
}

.add-btn, .add-sub-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.add-btn:hover, .add-sub-btn:hover {
  background: linear-gradient(135deg, #047857 0%, #10b981 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}

.delete-btn, .delete-sub-btn {
  background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.8rem;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.delete-btn:hover, .delete-sub-btn:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.delete-btn.disabled, .delete-sub-btn.disabled,
.add-btn.disabled, .add-sub-btn.disabled {
  background: #9ca3af;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.delete-btn.disabled:hover, .delete-sub-btn.disabled:hover,
.add-btn.disabled:hover, .add-sub-btn.disabled:hover {
  background: #9ca3af;
  transform: none;
  box-shadow: none;
}

@media (max-width: 768px) {
  .senate-buttons {
    flex-direction: column;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .item-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .subsection-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .status-header, .position-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>